export default __webpack_public_path__ + "static/media/solflare.21f161e5.png";